<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-01 15:15:13
 * @LastEditors: 张东 zhangdong265@jd.com
 * @LastEditTime: 2023-03-21 18:29:46
 * @FilePath: /content-center/src/components/wiki/EditorialPersonnel.vue
-->
<template>
  <div class="Editorandreviewer content-item flex align-items-center">
    <div class="content-item-label">
      <span class="red" v-if="JSON.parse(commonData[0].value) === '1'">*</span
      >{{ JSON.parse(commonData[1].value) || "编审人员" }}
    </div>
    <el-input
      v-model="form.authors[0].authorName"
      placeholder="请输入编审人员"
      clearablesize="mini"
    ></el-input>
  </div>
</template>
<script>
export default {
  name: "EditorialPersonnel",
  props: ["form", "commonData"],
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.Editorandreviewer {
  display: flex;
  margin-top: 20px;
  .content-item-label {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
  .red {
    color: #f62458;
    margin-right: 5px;
  }
  p {
  }
  // span {
  //   width: 107px;
  //   text-align: right;
  //   margin-right: 10px;
  //   -ms-flex-negative: 0;
  //   flex-shrink: 0;
  //   font-size: 14px;
  //   color: #2c3443;
  // }
  .el-input {
    width: 518px;
    :deep(.el-input__inner) {
      height: 32px !important;
    }
  }
}
</style>
